import React from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntForm, LntFormItem, LntModalFooter, LntSelect } from '@app/components/base'
import { LntTransfer } from '@app/components/base/Transfer'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { CONTRACTORS_KEY, LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'

import { getContractors } from '@app/api/routes/contractors'
import { getTypes } from '@app/api/routes/monitorings'
import { getClusters } from '@app/api/routes/locationСlusters'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import { getTransferItemsFromEntities, getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { SEPARATOR } from '@app/constants/separator'

import styles from './styles.module.scss'

import type { NewLinkContractorsModalProps } from '../types'
import type { PostContractorsClusterData } from '@app/api/routes/contractors/types'
import type { LntSelectProps } from '@app/components/base/Select/types'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  tokenSeparators: [SEPARATOR.newline]
}

export const NewConnectionContractorsForm: React.FC<Pick<NewLinkContractorsModalProps, 'onSubmit'>> = ({
  onSubmit
}) => {
  const form = useForm<PostContractorsClusterData>()
  const isValid = form.formState.isValid

  const handleSubmit = (data: PostContractorsClusterData): void => {
    onSubmit?.(data)
  }

  return (
    <LntForm
      layout='vertical'
      onSubmit={ handleSubmit }
      formInstance={ form }
    >
      <LntFormItem
        name='contractorId'
        defaultValue={ [] }
        validationOptions={ { rules: { required: 'Укажите подрядчика' } } }
        className={ styles.newConnectionContractorsFormItem }
      >
        <LntSelect
          showArrow
          size={ SIZE.middle }
          placeholder={ FILTERS_PLACEHOLDERS.contractorsFilter }
          querySelect={ {
            queryKey: [CONTRACTORS_KEY.contractorsItems],
            queryFn: getContractors,
            select: getFilterFromEntities
          } }
        />
      </LntFormItem>

      <LntFormItem
        name='monitoringTypeIds'
        defaultValue={ [] }
        validationOptions={ { rules: { required: 'Укажите тип мониторинга' } } }
        className={ styles.newConnectionContractorsFormItem }
      >
        <LntSelect
          { ...commonSelectProps }
          placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
          querySelect={ {
            queryKey: [MONITORINGS_TYPES_KEY.typesItems],
            queryFn: getTypes,
            select: getFilterFromEntities
          } }
        />
      </LntFormItem>

      <LntFormItem
        name='clusterIds'
        defaultValue={ [] }
        validationOptions={ { rules: { required: 'Укажите кластеры' } } }
        className={ styles.newConnectionContractorsFormItem }
      >
        <LntTransfer
          showSearch
          queryOptions={ {
            queryKey: [LOCATION_KEY.locationClustersItems],
            queryFn: getClusters,
            select: getTransferItemsFromEntities
          } }
        />
      </LntFormItem>

      <LntModalFooter>
        <LntButton
          htmlType='submit'
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          disabled={ !isValid }
        >
          Добавить
        </LntButton>
      </LntModalFooter>
    </LntForm>
  )
}
